module.exports = "<div class=\"kan-terms-list\">\n    <kan-term-list-item *ngFor=\"let term of terms\"\n                           [term]=\"term\"\n                           (refresh)=\"emitRefresh()\">\n    </kan-term-list-item>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/admin/components/term/list/component.html
// module id = ./src/modules/admin/components/term/list/component.html
// module chunks = main